import TIM from 'tim-js-sdk'
import config from '@/config'
import { Toast } from 'vant'
import user from './user'

export default {
  state: {
    tim: null,
    chatroom: '',
    latestMessage: {},
    joinMessage: {},
    deleteMessage: {},
    topMessage: {},
    remindMessage: {}
  },

  mutations: {
    setLatestMessage (state, message) {
      state.latestMessage = message
    },

    setJoinMessage (state, message) {
      if (message.nick !== state.joinMessage.nick) state.joinMessage = message
    },

    setTopMessage (state, message) {
      state.topMessage = message
    },

    setRemindMessage (state, message) {
      state.remindMessage = message
    }
  },

  actions: {
    initTim ({ dispatch, commit, state }, data) {
      state.chatroom = data.chatroom
      state.tim = TIM.create({ SDKAppID: config.imAppId })

      dispatch('readyListener')
      dispatch('receivedListener')

      state.tim.login({ userID: user.state.imAccount, userSig: user.state.imUsersig }).then(() => {
        state.nickname = user.state.nickname
        state.tim.joinGroup({ groupID: state.chatroom })
      })
    },

    submitInput ({ commit, state }, value) {
      if (state.tim) {
        let message = state.tim.createTextMessage({
          to: state.chatroom,
          conversationType: TIM.TYPES.CONV_GROUP,
          payload: { text: value }
        })

        message.nick = user.state.nickname || ''
        message.avatar = user.state.avatar || ''
        message.time = parseInt(new Date().getTime / 1000)

        state.tim.sendMessage(message).then(res => {
          commit('setLatestMessage', message)
        }).catch(err => {
          if (err.code === 10017) {
            Toast('您已被禁言，暂时不能发送消息')
          }
        })
      }
    },

    readyListener ({ state }) {
      state.tim.on(TIM.EVENT.SDK_READY, () => {})
    },

    receivedListener ({ commit, state }) {
      state.tim.on(TIM.EVENT.MESSAGE_RECEIVED, (event) => {
        console.warn('监听到数据 ....................')

        event.data.map(message => {
          console.log(message)
          switch (message.type) {
            case TIM.TYPES.MSG_TEXT:
              // 防止发送之后又收到自己的消息
              if (message.from !== user.id) commit('setLatestMessage', message)
              break

            case TIM.TYPES.MSG_CUSTOM:
              const data = JSON.parse(message.payload.data)

              if (data.type === 'REDP') {
                // 有红包领取时
                commit('changePopupVisible', {
                  id: data.sendId,
                  visible: true,
                  status: 'envelop',
                  ext: 'open'
                })
              } else if (data.type === 'PRIZE') {
                // 有奖品领取时
                commit('changePopupVisible', {
                  id: data.sendId,
                  visible: true, 
                  status: 'gifts', 
                  ext: ['open', data.prizeName, data.prizeImage]
                })
              } else if (data.type === 'STATUS') {
                // 直播状态变动时
                if (data.status === 'DOING') Toast('直播已开始，赶快去围观吧~')
                else if (data.status === 'STOP') Toast('直播暂停中，和大家唠唠嗑吧~')
                else if (data.status === 'FINISH') Toast('直播已结束，感谢您的观看~')

                commit('setRoomStatus', data.status)
              } else if (data.type === 'VIEWERS') {
                commit('setViewers', data.viewers)  // 修改观看人数
              } else if (data.type === 'TOP') {
                commit('setTopMessage', JSON.parse(data.topInfo))  // 置顶消息时
              } else if (data.type === 'DELETE_MSG') {
                state.deleteMessage = JSON.parse(data.msg)  // 删除消息时
              } else if (data.type === 'BANNER') {
                commit('setBannerUrl', data.bannerUrl)
              } else if (data.type === 'GOODS_ONSALE') {
                data.goodsDetail = JSON.parse(data.goodsDetail)
                data.goodsDetail.id = data.id
                commit('setProductOnsale', data.goodsDetail)
              } else if (data.type === 'REMIND') {
                commit('setRemindMessage', data)
              }

              break

            case TIM.TYPES.MSG_GRP_TIP:
              commit('setJoinMessage', message)
              break

            default:
              break
          }
        })
      })
    }
  },
}